export enum OnBoardingBits {
  NONE = 0,
  BOOST_TIP = 1 << 0,
  UNDO_TIP = 1 << 1,
  REACTION_PASS_TIP = 1 << 2,
  REACTION_HELLO_TIP = 1 << 3,
  REACTION_LIKE_TIP = 1 << 4,
  DISCOVER_CARD = 1 << 5,
  DISCOVER_MAP = 1 << 6,
  FEATURES_VISITS = 1 << 7,
  FEATURES_REACTIONS = 1 << 8,
  WELCOME = 1 << 9,
  DISCOVER_SWITCHER_TIP = 1 << 10,
  WELCOME_GOLD = 1 << 11,
  TRANSLATOR = 1 << 12,
  FILL_PROFILE = 1 << 13,
  SIMPLE_BOOST_TIP = 1 << 14,
  MATCHES_FAVOURITES = 1 << 15,
  REQUEST_VERIFICATION = 1 << 16,
  REQUEST_LOCATION_VERIFICATION = 1 << 18,
  COMPLIMENT_TIP = 1 << 19,
  TAP_TO_REVEAL_TIP = 1 << 20,
}
